module.exports = __webpack_public_path__ + "img/zubut-black.c13569e4.png";